import { render, staticRenderFns } from "./JobDetailStatus.vue?vue&type=template&id=169bfe0e&"
import script from "../../../services/admin/job/job-detail-status.js?vue&type=script&lang=js&"
export * from "../../../services/admin/job/job-detail-status.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports